export default {
    GET_OUTDOORS_CAMPAIGNS_REQUEST: state => {
        state.outdoorsCampaignsLoading = true
    },
    GET_OUTDOORS_CAMPAIGNS_SUCCESS: (state, data) => {
        state.outdoorsCampaigns = data.results
        state.outdoorsCampaignsLoading = false
    },
    GET_OUTDOORS_CAMPAIGNS_FAILURE: state => {
        state.outdoorsCampaignsLoading = false
    },
    GET_OUTDOORS_CAMPAIGN_LOCALIZATIONS_REQUEST: state => {
        state.outdoorsCampaignLocalizationsLoading = true
    },
    GET_OUTDOORS_CAMPAIGN_LOCALIZATIONS_SUCCESS: (state, data) => {
        state.outdoorsCampaignLocalizations = data.results
        state.outdoorsCampaignLocalizationsLoading = false
    },
    GET_OUTDOORS_CAMPAIGN_LOCALIZATIONS_FAILURE: state => {
        state.outdoorsCampaignLocalizationsLoading = false
    },
    SET_OUTDOORS_CAMPAIGN_FILTERS: (state, filters) => {
        state.filters = filters
    },
    GET_OUTDOORS_CAMPAIGN_LOCALIZATION_SCREENS_SUCCESS: (state, data) => {
        state.outdoorsCampaignLocalizationScreens = data.results
    },
    UPDATE_CAMPAIGN_CREATE_PRODUCT_LIST: (state, { product, productTemplate }) => {
        state.campaign.campaignProducts.push(product)
        state.productTemplates.push(productTemplate)
    },
    UPDATE_CAMPAIGN_CREATE_PRODUCT_TEMPLATE: (state, { index, product, productTemplate }) => {
        state.campaign.campaignProducts[index] = product
        state.productTemplates[index] = productTemplate
    },
    REMOVE_CAMPAIGN_CREATE_PRODUCT_TEMPLATE: (state, index) => {
        state.campaign.campaignProducts.splice(index, 1)
        state.productTemplates.splice(index, 1)
    },
    TEMPORARY_SAVE_CAMPAIGN_DATA: (state, data ) => {
        state.campaign = data.campaign
        state.customers = data.customers
    },
    CLEAR_CAMPAIGN_CREATE: (state) => {
        state.campaign = {}
        state.productTemplates = []
        state.customers = []
    },
    SET_CANCEL_TOKEN: (state, token) => {
        state.cancelToken = token
    },
    SET_IS_CAMPAIGN_CREATED: state => {
        state.isCampaignCreated = true
    },
    CLEAR_IS_CAMPAIGN_CREATED: state => {
        state.isCampaignCreated = false
    }
}